var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"code-link-edit"},[_c('edit-link',{attrs:{"ids":_vm.ids,"attrs":_vm.attrs,"partsContainerType":_vm.partsContainerType},on:{"change":function($event){return _vm.change($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }